import { IUser } from "../../../zabbix-shared/interfaces/intefaces";

class OnlineUserService {
  private user: IUser | null = null;
  private resolveUser: ((user: IUser) => void) | null = null;
  private userPromise: Promise<IUser>;

  constructor() {
    this.userPromise = new Promise(resolve => {
      this.resolveUser = resolve;
    });
  }

  setUser(user: IUser | null) {
    this.user = user;
    if (user && this.resolveUser) {
      this.resolveUser(user);
      this.resolveUser = null;
    }
  }

  getUser(): IUser | null {
    return this.user;
  }

  async waitForUser(): Promise<IUser> {
    if (this.user) return this.user;
    return this.userPromise;
  }

  clearUser() {
    this.user = null;
  }
}

export default new OnlineUserService();
